import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Swal from "sweetalert2";
import { Alert } from 'react-bootstrap';

const ProduitsAdmin = () => {
    const [products, setProducts] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [newProduct, setNewProduct] = useState({
        Name: '',
        Description: '',
        Price: '',
        StockQuantity: '',
        Category: 'Alimentaire', // default category
        image: ''
    });
    const [editingProductId, setEditingProductId] = useState(null);
const [loading, setLoading] = useState(false); // Ajout de l'�tat de chargement

    useEffect(() => {
        checkAdminStatus();
    }, []);

    const checkAdminStatus = () => {
        const isAdmin = localStorage.getItem('isAdmin') === '1';
        setIsAdmin(isAdmin);

        if (isAdmin) {
            fetchAllProducts();
        } else {
            console.error('Unauthorized: User is not an admin');
        }
    };

    const fetchAllProducts = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                console.error('JWT token not found in local storage');
                return;
            }

            const response = await axios.get('https://hbmdijital.online/api/admin/products', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                setProducts(response.data);
            } else {
                console.error('Failed to fetch products:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    const handleEdit = (productId) => {
        setEditingProductId(productId);
        const product = products.find(p => p.ProductID === productId);
        setNewProduct({
            Name: product.Name,
            Description: product.Description,
            Price: product.Price,
            Category: product.Category,
            StockQuantity: product.StockQuantity,
            image: product.image || ''
        });
        setShowModal(true);
    };

    const handleDelete = async (productId) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                console.error('JWT token not found in local storage');
                return;
            }

            Swal.fire({
                title: 'Êtes-vous sûr?',
                text: "Vous ne pourrez pas revenir en arrière!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Oui, supprimer!',
                cancelButtonText: 'Annuler'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const response = await axios.delete(`https://hbmdijital.online/api/admin/products/${productId}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });

                    if (response.status === 200) {
                        setProducts(products.filter(product => product.ProductID !== productId));
                        Swal.fire(
                            'Supprimé!',
                            'Le produit a été supprimé.',
                            'success'
                        );
                    } else {
                        console.error('Failed to delete product:', response.statusText);
                    }
                }
            });
        } catch (error) {
            console.error('Error deleting product:', error);
        }
    };

    const handleShowModal = () => {
        setEditingProductId(null);
        setNewProduct({
            Name: '',
            Description: '',
            Price: '',
            Category: 'Alimentaire',
            StockQuantity: '',
            image: ''
        });
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    const handleChange = (e) => {
        setNewProduct({ ...newProduct, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    setLoading(true); // Active le mode "loading"

        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                console.error('JWT token not found in local storage');
                return;
            }
    
            const formData = new FormData();
            formData.append('Name', newProduct.Name);
            formData.append('Description', newProduct.Description);
            formData.append('Price', newProduct.Price);
            formData.append('StockQuantity', newProduct.StockQuantity);
            formData.append('Category', newProduct.Category);
    
            // If it's not an edit, append the image
            if (!editingProductId && newProduct.image) {
                formData.append('image', newProduct.image);
            }
    
            let response;
            if (editingProductId) {
                // For editing, we don't append the image field
                response = await axios.put(
                    `https://hbmdijital.online/api/admin/products/${editingProductId}`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
            } else {
                response = await axios.post(
                    'https://hbmdijital.online/api/admin/products',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
            }
    
            if (response.status === 200 || response.status === 201) {
                fetchAllProducts();
                handleCloseModal();
    
                Swal.fire(
                    'Produit inséré avec succès!',
                    'Le produit a été inséré avec succès.',
                    'success'
                );
            } else {
                console.error('Failed to add/edit product:', response.statusText);
            }
        } catch (error) {
            console.error('Error adding/editing product:', error);
        }
    setLoading(false); // D�sactive le mode "loading"

    };
    

    if (!isAdmin) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Alert variant="danger" style={{ width: '80%', textAlign: 'center' }}>
                    Unauthorized: You do not have admin access.
                </Alert>
            </div>
        );
    }

    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex flex-column">
                <section className="w-100 p-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="text-dark display-4">Tableau de bord Admin - Produits</h6>
                    <button 
                        className="btn btn-lg"
                        style={{ 
                            backgroundColor: '#1e3d56', // Use your primary color
                            color: 'white', 
                            border: 'none', 
                            padding: '10px 20px', 
                            fontSize: '16px', 
                            borderRadius: '5px' 
                        }} 
                        onClick={handleShowModal}
                    >
Ajouter un produit                    </button>
                    </div>
                    <hr className="my-4" />

                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                <th>ID du produit</th>
                                <th>Nom</th>
                                <th>Description</th>
                                <th>Prix</th>
                                <th>Catégorie</th>
                                <th>Image</th>
                                <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {products.map((product) => (
                                    <tr key={product.ProductID}>
                                        <td>{product.ProductID}</td>
                                        <td>{product.Name}</td>
                                        <td>{product.Description}</td>
                                        <td>{product.Price} DH</td>
                                        <td>{product.Category}</td>
                                        <td>
                                            {product.image ? (
                                                <img
                                                    src={`https://hbmdijital.online/storage/${product.image}`}
                                                    alt={product.Name}
                                                    style={{ width: '50px', height: '50px' }}
                                                />
                                            ) : (
                                                'No Image'
                                            )}
                                        </td>
                                        <td>
                                            <button className="btn btn-warning btn-sm me-2" onClick={() => handleEdit(product.ProductID)}>Edit</button>
                                            <button className="btn btn-danger btn-sm" onClick={() => handleDelete(product.ProductID)}>Delete</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
            <Footer />
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{editingProductId ? 'Modifier le produit' : 'Ajouter un produit'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group>
                            <Form.Label>Nom</Form.Label>
                            <Form.Control type="text" name="Name" value={newProduct.Name} onChange={handleChange} required />
                        </Form.Group>
                    <Form.Group>
    <Form.Label>Description</Form.Label>
    <Form.Control as="textarea" name="Description" value={newProduct.Description} onChange={handleChange} required />
</Form.Group>
                        <Form.Group>
                            <Form.Label>Prix</Form.Label>
                            <Form.Control type="number" name="Price" value={newProduct.Price} onChange={handleChange} required />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Quantité en stock</Form.Label>
                            <Form.Control type="number" name="StockQuantity" value={newProduct.StockQuantity} onChange={handleChange} required />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Catégorie</Form.Label>
                            <Form.Control as="select" name="Category" value={newProduct.Category} onChange={handleChange} required>
                                <option value="Alimentaire">Alimentaire</option>
                                <option value="Cosmetique">Cosmetique</option>
                            </Form.Control>
                        </Form.Group>

                        {/* Display the image preview if editing */}
                        {editingProductId && newProduct.image && (
                            <div className="mb-3">
                                <Form.Label>Image actuelle</Form.Label>
                                <img 
                                    src={typeof newProduct.image === 'string' 
                                        ? `https://xn--cafnenero-d4a.com/storage/${newProduct.image}`  // ✅ Use this
                                        : URL.createObjectURL(newProduct.image)} 
                                    alt="Product Preview" 
                                    className="img-fluid" 
                                    style={{ maxWidth: "150px", borderRadius: "5px" }}
                                />
                            </div>
                        )}

                        {/* Image Upload Input (only for adding) */}
                        {!editingProductId && (
                            <Form.Group>
                                <Form.Label>Télécharger l'image</Form.Label>
                                <Form.Control 
                                    type="file" 
                                    name="image" 
                                    onChange={(e) => setNewProduct({ ...newProduct, image: e.target.files[0] })} 
                                />
                            </Form.Group>
                        )}

                     <Button variant="primary" type="submit" disabled={loading}>
    {loading ? (
        <>
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {' '} En cours...
        </>
    ) : (
        editingProductId ? 'Modifier' : 'Ajouter'
    )}
</Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </AnimationRevealPage>
    );
};

export default ProduitsAdmin;
